import ReviewOrderPage from './ReviewOrderPage'
import connect from './connect'

export default connect(ReviewOrderPage)
